"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Returns a Date object plus x weeks
 * @param weeks
 * @return {Date}
 */
const getDateInXDays_1 = __importDefault(require("./getDateInXDays"));
exports.default = (weeks = 0) => {
    return (0, getDateInXDays_1.default)(weeks * 7);
};
